import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
    Typography, Grid, Avatar, IconButton,
} from '@material-ui/core';
import { Edit, InfoOutlined } from '@material-ui/icons';
import './BaseInfoSummary.scss';
import ChipCompletedStep from '@commonClient2/components/ChipCompletedStep';
import { UPDATE_DRAFT_BID_PROFILE_OBJECTS } from '../../../store/bidProfileDraft';
import { UPDATE_BID_PROFILE_OBJECTS } from '../../../store/bidProfile';
import { BidProfileEditTab } from '../../../../Enums';

function BaseInfoSummary() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    /** @type {ShiftBidding.ManagerStore} */
    // @ts-ignore
    const { bidProfileDraft, bidProfile, managerAppData } = useSelector((state) => state);

    const { t } = useTranslation('shiftBidding');
    const { managerBidSetups } = managerAppData;

    let handleEdit = () => { };

    /**
     * @type {BiddingDraft.IBidProfileDraft | BidProfile.IBidProfile | undefined}
     */
    let profile;
    let isDraft = false;
    if (bidProfileDraft.id !== '') {
        profile = bidProfileDraft;
        isDraft = true;

        handleEdit = () => {
            dispatch({
                type: UPDATE_DRAFT_BID_PROFILE_OBJECTS,
                payload: {
                    general: {
                        tabSelected: BidProfileEditTab.Form,
                    },
                    bidProfileInformation: {
                        isExpanded: true,
                    },
                    scheduleTemplates: {
                        isExpanded: false,
                    },
                    employees: {
                        isExpanded: false,
                    },
                    schedule: {
                        isExpanded: false,
                    },
                },
            });
            navigate('/Manager/form');
        };
    } else if (bidProfile.id !== '') {
        profile = bidProfile;
        isDraft = false;

        handleEdit = () => {
            dispatch({
                type: UPDATE_BID_PROFILE_OBJECTS,
                payload: {
                    general: {
                        tabSelected: BidProfileEditTab.Form,
                    },
                    bidProfileInformation: {
                        isExpanded: true,
                    },
                    scheduleTemplates: {
                        isExpanded: false,
                    },
                    employees: {
                        isExpanded: false,
                    },
                    schedule: {
                        isExpanded: false,
                    },
                },
            });
            navigate('/Manager/form');
        };
    }

    // @ts-ignore
    if (profile === undefined) {
        return <></>;
    }

    const {
        bidProfileInformation,
        originalBidProfileInformation,
        isCreationAllowed,
        isViewAllowed
    } = profile;
    const selectedSetup = managerBidSetups.find((config) => config.bidSetupId === originalBidProfileInformation.bidSetupId);

    return (
        <div className="summary-section">
            <div className="summary-section-header">
                <div className="summary-section-avatar-title-wrapper">
                    <Avatar className="bde-avatar">1</Avatar>
                    <Typography variant="h6">{t('form.baseInfoSubHeader')}</Typography>
                </div>

                <Grid
                    item
                    className="summary-section-indicator-container"
                >
                    {isDraft ? (
                        <span
                            className="summary-completed-icon-wrapper"
                        >
                            {
                                originalBidProfileInformation.isCompleted && <ChipCompletedStep />
                            }
                        </span>
                    ) : null}
                    {(isCreationAllowed || isViewAllowed) && (
                        <IconButton
                            color="primary"
                            className="summary-edit-button"
                            onClick={() => handleEdit()}
                        >
                            {(bidProfileInformation.isEditable && isCreationAllowed) ? <Edit /> : <InfoOutlined />}
                        </IconButton>
                    )}
                </Grid>
            </div>
            <div className="summary-section-content">
                <div>
                    <Typography
                        variant="body1"
                        display="inline"
                    >
                        {t('form.name')}
                        {' '}
                        :
                    </Typography>
                    <Typography
                        className="bi-summary-name"
                        variant="body2"
                        display="inline"
                    >
                        {' '}
                        {originalBidProfileInformation.name}
                    </Typography>
                </div>
                <div>
                    <Typography
                        variant="body1"
                        display="inline"
                    >
                        {' '}
                        {t('form.description')}
                        {' '}
                        :
                    </Typography>
                    <Typography
                        className="bi-summary-description"
                        variant="body2"
                        display="inline"
                    >
                        {' '}
                        {originalBidProfileInformation.description}
                        {' '}
                    </Typography>
                </div>
                <div>
                    <Typography
                        variant="body1"
                        display="inline"
                    >
                        {' '}
                        {t('form.bidSetup')}
                        {' '}
                        :
                    </Typography>
                    <Typography
                        variant="body2"
                        display="inline"
                    >
                        {' '}
                        {selectedSetup?.name}
                        {' '}
                    </Typography>
                </div>
            </div>
        </div>
    );
}

export default BaseInfoSummary;
